import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, ShieldAlert } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const fmt = (v) => (v ? new Date(v).toLocaleString() : "—");
const mins = (a, b) => (a && b ? Math.max(0, Math.round((new Date(b) - new Date(a)) / 60000)) : null);

// Admin-only history of "Act as this school" sessions (admin, school, start, end).
export default function ActAsLogPage() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    axios.get(`${API}/api/admin/act-as/log`, { withCredentials: true })
      .then((r) => setRows(r.data.sessions || []))
      .catch((e) => { setErr(e?.response?.data?.detail || "Couldn't load act-as sessions"); setRows([]); });
  }, []);
  return (
    <div className="p-6 max-w-6xl space-y-4" data-testid="act-as-log-page">
      <div>
        <h1 className="text-2xl font-semibold text-[#111827] inline-flex items-center gap-2"><ShieldAlert className="h-6 w-6 text-[#f59e0b]" /> Act-as Sessions</h1>
        <p className="text-sm text-[#6b7280] mt-1">Every time a MySchoolRx admin acted as a school.</p>
      </div>
      {err && <div className="text-sm text-red-600" data-testid="act-as-log-error">{err}</div>}
      <div className="overflow-x-auto rounded-xl border border-[#e5e7eb] bg-white">
        <table className="w-full text-sm">
          <thead className="bg-[#f9fafb] text-left text-xs uppercase text-[#6b7280]">
            <tr><th className="px-4 py-3">School</th><th className="px-4 py-3">Admin</th><th className="px-4 py-3">Started</th><th className="px-4 py-3">Ended</th><th className="px-4 py-3">Minutes</th></tr>
          </thead>
          <tbody>
            {rows === null && <tr><td colSpan={5} className="px-4 py-8 text-center"><Loader2 className="h-5 w-5 animate-spin inline text-[#9ca3af]" /></td></tr>}
            {rows?.map((r) => (
              <tr key={r.id} className="border-t border-[#f1f2f4]" data-testid={`act-as-log-row-${r.id}`}>
                <td className="px-4 py-3 font-medium text-[#111827]">{r.school_name}</td>
                <td className="px-4 py-3 text-[#374151]">{r.admin_email || r.admin_user_id}</td>
                <td className="px-4 py-3 text-[#374151]">{fmt(r.started_at)}</td>
                <td className="px-4 py-3 text-[#374151]">{r.ended_at ? fmt(r.ended_at) : (Date.now() - new Date(r.started_at) > 60 * 60000)
                  ? <span className="rounded-full bg-[#f3f4f6] px-2 py-0.5 text-xs font-semibold text-[#6b7280]">Expired · no Exit</span>
                  : <span className="rounded-full bg-[#fef3c7] px-2 py-0.5 text-xs font-semibold text-[#92400e]">Active</span>}</td>
                <td className="px-4 py-3 text-[#6b7280]">{mins(r.started_at, r.ended_at) ?? "—"}</td>
              </tr>
            ))}
            {rows && rows.length === 0 && !err && <tr><td colSpan={5} className="px-4 py-8 text-center text-[#9ca3af]">No act-as sessions yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
